export const environment = {
    baseUrl: "https://www.bienesraicesdeloriente.com",
    encryptionKey: "LKQq3ZZ7jGKmUq7RneylfhCXOQJJ64crC1EGMTCSYNw=",
    googleMapsApiKey: ""
};
